import { GroupedList, IGroup, IGroupHeaderProps, IRenderFunction, List, Stack, StackItem, Text } from '@fluentui/react';
import React, { useContext, useEffect, useState } from 'react';
import { AppStateContext } from '../../state/AppProvider';
import { ChatHistoryListItemGroups } from './ChatHistoryListItem';
import { Conversation } from '../../api/models';

interface ChatHistoryListProps {
  searchTerm: string;
}
export interface GroupedChatHistory {
    month: string;
    entries: Conversation[]
}

const groupByMonth = (entries: Conversation[]) => {
    const groups: GroupedChatHistory[] = [{ month: "Recent", entries: [] }];
    const currentDate = new Date();
  
    entries.forEach((entry) => {
        const date = new Date(entry.date);
        const daysDifference = (currentDate.getTime() - date.getTime()) / (1000 * 60 * 60 * 24);
        const monthYear = date.toLocaleString('default', { month: 'long', year: 'numeric' })
        const existingGroup = groups.find((group) => group.month === monthYear);
        
        if(daysDifference <= 7){
            groups[0].entries.push(entry);
        }else{
            if (existingGroup) {
                existingGroup.entries.push(entry);
            } else {
                groups.push({ month: monthYear, entries: [entry] });
            }
        }
    });

    groups.sort((a, b) => {
        // Check if either group has no entries and handle it
        if (a.entries.length === 0 && b.entries.length === 0) {
            return 0; // No change in order
        } else if (a.entries.length === 0) {
            return 1; // Move 'a' to a higher index (bottom)
        } else if (b.entries.length === 0) {
            return -1; // Move 'b' to a higher index (bottom)
        }
        const dateA = new Date(a.entries[0].date);
        const dateB = new Date(b.entries[0].date);
        return dateB.getTime() - dateA.getTime();
    });

    groups.forEach((group) => {
        group.entries.sort((a, b) => {
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);
            return dateB.getTime() - dateA.getTime();
        });
    });
  
    return groups;
};

const ChatHistoryList: React.FC<ChatHistoryListProps> = ({ searchTerm }) => {
  const appStateContext = useContext(AppStateContext);
  const chatHistory = appStateContext?.state.chatHistory;
  



  if (!chatHistory || chatHistory.length === 0) {
    return (
      <Stack horizontal horizontalAlign="center" verticalAlign="center" style={{ width: '100%', marginTop: 10 }}>
        <StackItem>
          <Text style={{ alignSelf: 'center', fontWeight: '400', fontSize: 14 }}>
            <span>No chat history.</span>
          </Text>
        </StackItem>
      </Stack>
    );
  }

  const [aiFiltered, setAiFiltered] = useState<any[]>([]);

const model = appStateContext.state.selectedAI;

const modelOnly = appStateContext?.state.modelCategory || [];
const appOnly = appStateContext?.state.appCategory || [];

useEffect(() => {
 
  if (!model || (modelOnly.length === 0 && appOnly.length === 0)) {
    return;
  }

  const filtered = chatHistory.filter((item) =>
    item.title?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  let aiFilter: any[] = [];

  const isModel = modelOnly.some((m: any) => m.Name === model);
  const isApp = appOnly.some((a: any) => a.Name === model);

  if (isModel) {
    aiFilter = filtered.filter((item: any) => item.ml_service === "MultiModel");
  } else if (isApp) {
    aiFilter = filtered.filter((item: any) => item.ml_service === model);
  } else {
    aiFilter = filtered;
  }

  appStateContext?.dispatch({
    type: "FILTERED_CHAT_HISTORY_BY_MODEL",
    payload: aiFilter,
  });

  setAiFiltered(aiFilter);
}, [chatHistory, searchTerm, model, modelOnly, appOnly]);





  if (aiFiltered.length === 0) {
    return (
      <Stack horizontal horizontalAlign="center" verticalAlign="center" style={{ width: '100%', marginTop: 10 }}>
        <StackItem>
          <Text style={{ alignSelf: 'center', fontWeight: '400', fontSize: 14 }}>
            <span>No results found.</span>
          </Text>
        </StackItem>
      </Stack>
    );
  }
  const FetchedAiFiltered = appStateContext?.state.filteredChatHistoryByModel || [];






   const groupedChatHistory = groupByMonth(FetchedAiFiltered);



  return <ChatHistoryListItemGroups groupedChatHistory={groupedChatHistory} />;
};

export default ChatHistoryList;
